<div class="companion container-lg py-3">
  <div class="companion__head">
    <div>
      <h1 class="companion__title">{{ 'companion.title' | translate }}</h1>
      <p class="companion__intro">{{ 'companion.intro' | translate }}</p>
    </div>
    @if (overview(); as o) {
      @if (o.entitlement.status === 'active') {
        <span class="companion__term">{{ 'companion.term.days_left' | translate:{ days: o.entitlement.days_left } }}</span>
      }
    }
  </div>

  @if (clock(); as c) {
    @if (c.time_travel && overview()?.profile) {
      <div class="companion__clock" role="note">
        <strong>{{ 'companion.clock.title' | translate }}</strong>
        <span class="companion__clock-day">
          {{ c.today | date:'dd.MM.yyyy' }}
          @if (c.simulated) { <em>({{ 'companion.clock.real' | translate:{ date: (c.real_today | date:'dd.MM.yyyy') } }})</em> }
        </span>
        <button type="button" cButton size="sm" color="secondary" variant="outline" [disabled]="clockBusy()" (click)="shiftClock(-1)">−1</button>
        <button type="button" cButton size="sm" color="secondary" variant="outline" [disabled]="clockBusy()" (click)="shiftClock(1)">+1</button>
        <button type="button" cButton size="sm" color="secondary" variant="outline" [disabled]="clockBusy()" (click)="shiftClock(7)">+7</button>
        <input type="date" class="form-control form-control-sm companion__clock-input" [value]="c.today" [disabled]="clockBusy()"
               (change)="setClock($any($event.target).value)" [attr.aria-label]="'companion.clock.title' | translate">
        @if (c.simulated) {
          <button type="button" cButton size="sm" color="secondary" [disabled]="clockBusy()" (click)="setClock(null)">{{ 'companion.clock.reset' | translate }}</button>
        }
        <span class="companion__clock-hint">{{ 'companion.clock.hint' | translate }}</span>
      </div>
    }
  }

  @if (loading()) {
    <div class="text-center py-4"><c-spinner /></div>
  } @else if (error(); as e) {
    <div class="card companion__card"><div class="card-body">{{ ('companion.errors.' + e) | translate }}</div></div>
  } @else if (overview(); as o) {

    @if (o.entitlement.status === 'none') {
      <div class="card companion__card"><div class="card-body">
        <h2 class="companion__h">{{ 'companion.not_entitled.title' | translate }}</h2>
        <p class="mb-0">{{ 'companion.not_entitled.text' | translate }}</p>
      </div></div>
    } @else {

      @if (o.entitlement.status === 'expired') {
        <div class="alert alert-secondary companion__notice">{{ 'companion.term.expired' | translate }}</div>
      }
      @if (o.entitlement.status === 'minor_consent_required') {
        <div class="alert alert-warning companion__notice">{{ 'companion.guardian.locked_notice' | translate }}</div>
      }
      @if (!o.provider.available && o.entitlement.status === 'active' && o.profile?.ai_enabled) {
        <div class="alert alert-secondary companion__notice">{{ 'companion.provider_unavailable' | translate }}</div>
      }

      @if (needsProfile() && !locked()) {
        <div class="companion__start" role="status">
          <strong>{{ 'companion.onboarding.notice_title' | translate }}</strong>
          <span>{{ 'companion.onboarding.notice_text' | translate:{ step: onboardingStep(), total: 8 } }}</span>
          @if (tab() !== 'profile') {
            <button cButton color="primary" size="sm" (click)="select('profile')">{{ 'companion.onboarding.go_profile' | translate }}</button>
          }
        </div>
      }

      <nav class="companion__tabs" role="tablist">
        @for (t of tabs; track t) {
          <button type="button" class="companion__tab" role="tab" [attr.aria-selected]="tab() === t"
                  [class.companion__tab--active]="tab() === t"
                  [disabled]="t === 'today' && (needsProfile() || locked())"
                  [attr.title]="t === 'today' && (needsProfile() || locked()) ? ('companion.onboarding.today_locked' | translate) : null"
                  (click)="select(t)">
            {{ ('companion.tabs.' + t) | translate }}
          </button>
        }
      </nav>

      @switch (tab()) {
        @case ('today') {
          <app-companion-today [overview]="o" [readOnly]="readOnly()" [lang]="lang()" (changed)="reload()" />
        }
        @case ('diary') {
          <app-companion-diary [overview]="o" [readOnly]="readOnly()" [lang]="lang()" (changed)="reload()" />
        }
        @case ('profile') {
          <app-companion-profile [overview]="o" [readOnly]="readOnly()" [lang]="lang()" (changed)="reload()" />
        }
        @case ('settings') {
          <app-companion-settings [overview]="o" [readOnly]="readOnly()" [lang]="lang()" (changed)="reload()" />
        }
      }
    }
  }
</div>
